module.exports = __webpack_public_path__ + "img/appltCourse-img19.1b4e9d9c.png";